import { AdData, GraphStats, StatisticsService, Stats } from './statistics.service'; 
import { UploadService, Region, Ad, Country,  City } from './../upload/upload.service'; 
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IMultiSelectSettings, IMultiSelectTexts, IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Auth, AuthService } from '../login/auth.service';
import { ChartDataSets } from 'chart.js';
import { DatePipe, DecimalPipe  } from '@angular/common';
import * as moment from 'moment';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;


const debounce = <A>(f:(a:A)=>void, delay:number) => {
 
  let timer:any = null;

  return (a:A)=> {

      if(!timer) {
        timer = setTimeout(()=>f(a), delay);
      }else{
        clearTimeout(timer);
        timer = setTimeout(()=>f(a), delay); 
      }
  }
}

class StatsView {
  public keyPerformanceIndicators: KeyPerformanceIndicators
  public genderAndAgeGroups: GenderAndAgeGroups
}

class KeyPerformanceIndicators {
  adSpendGross: string
  adSpendNet: string
  airTime: string
  numberOfPlaybacks: string
  views: string
  viewsPerMin: string
  CPVGross: string
  CPVNet: string
  impressions: string
  impressionsPerMinute: string
  CPMGross: string
  CPMNet: string
}

class GenderAndAgeGroups {
  percentages: number[]
  chartPercentageLabels: string[]
  barChartLabels: string[]
  barChartData: ChartDataSets[]
  percentagePerAgeGroup: number[]
}

class GraphStatsView {
  dates: string[]
  viewsData: ChartDataSets[]
  viewsPerMinData: ChartDataSets[]
}

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [StatisticsService, UploadService, DatePipe, DecimalPipe]
})
export class DashboardPage implements OnInit {
 
  public statsView: StatsView = new StatsView();
  public graphStatsView: GraphStatsView = new GraphStatsView();
  public regions: Array<Region>;
  public ads: Array<Ad>;
  public ad_ids: Array<Number>;
  public region_ids: Array<Number>;
  public country_ids: Array<Number>;
  public city_ids: Array<Number>;

  public countries: Array<Country> = [];
  public cities: Array<IMultiSelectOption> = [];

  isAdFilterSet(): boolean {
    return this.ad_ids !== undefined && this.ad_ids.length > 0;
  }

  isCountryFilterSet(): boolean {
    return this.country_ids !== undefined && this.country_ids.length > 0;
  }

  isCityFilterSet(): boolean {
    return this.city_ids !== undefined && this.city_ids.length > 0;
  }

  isRegionFilterSet(): boolean {
    return this.region_ids !== undefined && this.region_ids.length > 0;
  }

  isDateFilterSet(): boolean {
    return this.selectedDates !== undefined && this.selectedDates.length > 0;
  }
  
  public mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block multiple-dropdown',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    fixedTitle: true
  }

  public adTexts: IMultiSelectTexts = {
    defaultTitle: 'Ad name'
  }

  public regionTexts: IMultiSelectTexts = {
    defaultTitle: 'Zone'
  }

  public countryTexts: IMultiSelectTexts = {
    defaultTitle: 'Country'
  }

  public cityTexts: IMultiSelectTexts = {
    defaultTitle: 'City'
  }

  public selectedDates: Array<NgbDateStruct> = [];
  public minDate: NgbDateStruct;
  public maxDate: NgbDateStruct;
  public dateSelectionMode: boolean = true; 
  public userSelectedDates: boolean = false; 

  public before = before;
  public after = after;
  public equals = equals;

  public showCalendar: boolean = false;
  public refresh: Function = debounce(() => this._refresh(), 600);
  public updating: Promise<any>;
  dataLoaded: boolean = false;

  constructor(public statisticsService: StatisticsService, public uploadService: UploadService, private calendar: NgbCalendar, private auth: AuthService, private datePipe: DatePipe, private decimalPipe: DecimalPipe) {
    this.refresh();
    this.uploadService.regions({for_stats: 1}).then(result => {
      this.regions = result;
    });
    this.uploadService.ads().then(result => {
      this.ads = result;
    });

    this.maxDate = calendar.getNext(calendar.getToday());

    const today = calendar.getToday(); // Get the current date
    this.selectedDates.push(today);

    for (let i = 1; i <= 6; i++) {
      const previousDate = calendar.getPrev(today, 'd', i); // Get the previous date
      this.selectedDates.unshift(previousDate); // Add the previous date to the beginning of the array
    }

    this.uploadService.geoForStats().then(result => {
      this.countries = result;
      
      let cities: IMultiSelectOption[] = [];
      result.forEach((country, index) => {
        cities.push({id: -index, name: country.name, isLabel: true});
        country.cities.forEach(city => {
          cities.push({id: city.id, name: city.name, parentId: -index});
        });
      });
      this.cities = cities;
    });
  }

  ngOnInit() {
    window.onbeforeunload = function (e) {
    // do nothing
    return
    }

  }

  onAdSelectionChange(selectedValues: number[]): void {
    if (selectedValues.length > 0 && !this.userSelectedDates) {
      this.selectedDates = []
    }
  }

  public clear()
  {
    this.ad_ids = [];
    this.region_ids = [];
    this.country_ids = [];
    this.city_ids = [];
    this.selectedDates = [];
    this.refresh();
  }

  public _refresh()
  {
    this.dataLoaded = false;

    let dates: Array<string> = [];
    this.selectedDates.forEach(date => {
      dates.push(this.formatDate(date));
    });

    // if user deselected all dates or did not select anything from date filter
    if(dates.length === 0 || !this.userSelectedDates) {
      // if there is at least 1 add selected
     if (this.ad_ids !== undefined && this.ad_ids.length > 0) {
       const selectedAds: Ad[] = this.ads.filter(ad => this.ad_ids.includes(ad.id))
       dates = this.convertAdsToDatesArray(selectedAds)
     } else {
       // if there are no ads selected then filter by current date and 6 days before current
       dates = []
       const today = this.calendar.getToday(); // Get the current date
       dates.push(this.formatDate(today));

       for (let i = 1; i <= 6; i++) {
         const previousDate = this.calendar.getPrev(today, 'd', i); // Get the previous date
         dates.unshift(this.formatDate(previousDate)); // Add the previous date to the beginning of the array
       }
      }
    }

    let params:any = {
        ad_ids: this.ad_ids,
        region_ids: this.region_ids,
        dates: dates,
        country_ids: this.country_ids
    };
    
    if (this.city_ids) {
      params.city_ids = this.city_ids.filter(id => id>0);
    }

    // Create two promises for each service call
    const promise1 = this.statisticsService.getDashboardStats(params).then(result => {
        this.statsView = this.mapStats(result);
      });
    
    const promise2 = this.statisticsService.getStatsGraphs(params).then(result => {
        this.graphStatsView = this.mapGraphStats(result, dates);
      });
    
    // Use Promise.all() to execute the promises in parallel
    Promise.all([promise1, promise2])
      .then(() => {
        this.dataLoaded = true;
      })
      .catch(error => {
        // Handle error if any of the promises fail
        console.error('Error occurred:', error);
      });
  }

  getDatesBetweenStartAndEnd(ad: Ad): string[] {
    const startDate = new Date(ad.start_date);
    const endDate = new Date(ad.end_date);
    const dateArray: string[] = [];

    var startDateStringWithoutTime = moment(startDate).format('YYYYMMDD');
    const endDateStringWithoutTime = moment(endDate).format('YYYYMMDD');
    
    // Iterate from start_date to end_date and add each date to the array
    while (startDateStringWithoutTime <= endDateStringWithoutTime) {
      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      
      if (!dateArray.includes(formattedDate)) {
        dateArray.push(formattedDate);
      }
      
      // Increment the date for the next iteration
      startDate.setDate(startDate.getDate() + 1);
      startDateStringWithoutTime = moment(startDate).format('YYYYMMDD');
    }
    
    return dateArray;
  }

  convertAdsToDatesArray(ads: Ad[]): string[] {
    const dateArray: string[] = [];

    for (const ad of ads) {
      const adDates = this.getDatesBetweenStartAndEnd(ad);

      for (const date of adDates) {
        if (!dateArray.includes(date)) {
          dateArray.push(date);
        }
      }
    }

    // Sort the dateArray
    dateArray.sort();

    return dateArray;
  }

  mapStats(stats: Stats): StatsView {
    const male_0_11 = stats.male_0_11 !== undefined ? stats.male_0_11 : 0
    const male_12_17 = stats.male_12_17 !== undefined ? stats.male_12_17 : 0
    const male_18_24 = stats.male_18_24 !== undefined ? stats.male_18_24 : 0
    const male_25_34 = stats.male_25_34 !== undefined ? stats.male_25_34 : 0
    const male_35_44 = stats.male_35_44 !== undefined ? stats.male_35_44 : 0
    const male_45_54 = stats.male_45_54 !== undefined ? stats.male_45_54 : 0
    const male_55_64 = stats.male_55_64 !== undefined ? stats.male_55_64 : 0
    const male_65_74 = stats.male_65_74 !== undefined ? stats.male_65_74 : 0
    const male_75 = stats.male_75 !== undefined ? stats.male_75 : 0

    const female_0_11 = stats.female_0_11 !== undefined ? stats.female_0_11 : 0
    const female_12_17 = stats.female_12_17 !== undefined ? stats.female_12_17 : 0
    const female_18_24 = stats.female_18_24 !== undefined ? stats.female_18_24 : 0
    const female_25_34 = stats.female_25_34 !== undefined ? stats.female_25_34 : 0
    const female_35_44 = stats.female_35_44 !== undefined ? stats.female_35_44 : 0
    const female_45_54 = stats.female_45_54 !== undefined ? stats.female_45_54 : 0
    const female_55_64 = stats.female_55_64 !== undefined ? stats.female_55_64 : 0
    const female_65_74 = stats.female_65_74 !== undefined ? stats.female_65_74 : 0
    const female_75 = stats.female_75 !== undefined ? stats.female_75 : 0

    const maleTotal =
      male_0_11 +
      male_12_17 +
      male_18_24 +
      male_25_34 +
      male_35_44 +
      male_45_54 +
      male_55_64 +
      male_65_74 +
      male_75

    const femaleTotal =
      female_0_11 +
      female_12_17 +
      female_18_24 +
      female_25_34 +
      female_35_44 +
      female_45_54 +
      female_55_64 +
      female_65_74 +
      female_75

    const maleAndFemaleTotal = maleTotal + femaleTotal

    return {
      keyPerformanceIndicators: {
        adSpendGross: this.formatNumber(stats.ad_spent_gross != undefined ? stats.ad_spent_gross : 0, '1.2-2'),
        adSpendNet: this.formatNumber(stats.ad_spent_net != undefined ? stats.ad_spent_net : 0, '1.2-2'),
        airTime: this.formatNumber(stats.air_time != undefined ? stats.air_time : 0, '1.0-0'),
        numberOfPlaybacks: this.formatNumber(stats.number_of_playbacks != undefined ? stats.number_of_playbacks : 0, '1.0-0'),
        views: this.formatNumber(stats.views != undefined ? stats.views : 0, '1.0-0'),
        viewsPerMin: this.formatNumber(stats.views_per_minute != undefined ? stats.views_per_minute : 0, '1.2-2'),
        CPVGross: this.formatNumber(stats.cpv_gross != undefined ? stats.cpv_gross : 0, '1.2-2'),
        CPVNet: this.formatNumber(stats.cpv_net != undefined ? stats.cpv_net : 0, '1.2-2'),
        impressions: this.formatNumber(stats.impressions != undefined ? stats.impressions : 0, '1.0-0'),
        impressionsPerMinute: this.formatNumber(stats.impressions_per_minute != undefined ? stats.impressions_per_minute : 0, '1.2-2'),
        CPMGross: this.formatNumber(stats.cpm_impression_gross != undefined ? stats.cpm_impression_gross : 0, '1.2-2'),
        CPMNet: this.formatNumber(stats.cpm_impression_net != undefined ? stats.cpm_impression_net : 0, '1.2-2')
      }, 
      genderAndAgeGroups: {
        percentages: maleAndFemaleTotal 
          ? [
              parseFloat((femaleTotal / maleAndFemaleTotal * 100).toFixed(1)), 
              parseFloat((maleTotal / maleAndFemaleTotal * 100).toFixed(1))
            ] 
          : [0,0],
        chartPercentageLabels: maleAndFemaleTotal 
          ? [
              this.formatNumber(femaleTotal / maleAndFemaleTotal * 100, '1.0-1'), 
              this.formatNumber(maleTotal / maleAndFemaleTotal * 100, '1.0-1')
            ] 
          : ["0","0"],
        barChartLabels: ["75+", "67-74", "55-64", "45-54", "35-44", "25-34", "18-24", "12-17", "0-11"],
        barChartData: [
          { 
            data: femaleTotal ? this.adjustPercentagesToHaveASumOf100([
              parseFloat((female_75 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_65_74 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_55_64 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_45_54 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_35_44 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_25_34 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_18_24 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_12_17 / femaleTotal * 100).toFixed(1)), 
              parseFloat((female_0_11 / femaleTotal * 100).toFixed(1)),
            ]) : [0,0,0,0,0,0,0,0,0], 
            label: "Female", 
            backgroundColor: '#d091b5'
          },
          { 
            data: maleTotal ? this.adjustPercentagesToHaveASumOf100([
              parseFloat((male_75 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_65_74 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_55_64 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_45_54 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_35_44 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_25_34 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_18_24 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_12_17 / maleTotal * 100).toFixed(1)), 
              parseFloat((male_0_11 / maleTotal * 100).toFixed(1)),
            ]) : [0,0,0,0,0,0,0,0,0], 
            label: "Male", 
            backgroundColor: '#56b3e3'
          },
        ],
        percentagePerAgeGroup:  maleAndFemaleTotal 
          ? this.adjustPercentagesToHaveASumOf100([
            parseFloat(((female_75 + male_75) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_65_74 + male_65_74) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_55_64 + male_55_64) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_45_54 + male_45_54) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_35_44 + male_35_44) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_25_34 + male_25_34) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_18_24 + male_18_24) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_12_17 + male_12_17) / maleAndFemaleTotal * 100).toFixed(1)), 
            parseFloat(((female_0_11 + male_0_11) / maleAndFemaleTotal * 100).toFixed(1)), 
          ]) 
          : [0,0,0,0,0,0,0,0,0]
      }
    }
  }

  adjustPercentagesToHaveASumOf100(percentages: number[]): number[] {
    // Calculate the sum of all elements
    const sum = percentages.reduce((acc, curr) => acc + curr, 0);

    // Calculate the amount needed to reach 100.0
    var amountToAdd = 100.0 - sum;
    if (Math.abs(amountToAdd) <= 0.05) {
      return percentages
    }

    // Sort the values in descending order and keep the original indices
    const sortedValues = percentages.map((value, index) => ({ value, index }));
    sortedValues.sort((a, b) => b.value - a.value);

    // Initialize an index for adjusting values
    let indexToAdjust = 0;

    let counter = 0;
    // Adjust values until the sum reaches 100.0
    while (Math.abs(amountToAdd) > 0.05) {
        const index = sortedValues[indexToAdjust].index;
        percentages[index] += (amountToAdd > 0) ? 0.1 : -0.1;
        amountToAdd -= (amountToAdd > 0) ? 0.1 : -0.1;
        indexToAdjust = (indexToAdjust + 1) % percentages.length;

        if (counter >= 20) {
          break;
        }
        counter++;
    }

    return percentages
  }

  mapGraphStats(stats: GraphStats, dates: string[]): GraphStatsView {
    if (stats == undefined || stats.graph_stats == undefined) {
      return {
        dates: [],
        viewsData: [],
        viewsPerMinData: []
      }
    }

    stats.graph_stats.sort((a: AdData, b: AdData) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA.getTime() - dateB.getTime();
    });
    dates.sort((a: string, b: string) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA.getTime() - dateB.getTime();
    });

    const colors: string[] = ["#635392", "#af9bde", "#9279cd", "#c9b4f1", "#ceced7", "#848c90"] // TODO: maybe add more colors

    const viewsData: ChartDataSets[] = []
      viewsData.push({
        data: stats.graph_stats.map((ad: AdData) => ad.views),
        backgroundColor: colors[0]
    })

    const viewsPerMinData: ChartDataSets[] = []
      viewsPerMinData.push({
        data: stats.graph_stats.map((ad: AdData) => ad.view_per_minute),
        backgroundColor: colors[0]
    })

    const graphStatsView = {
      dates: dates.map((dateString) => {
        const date = new Date(dateString);
        const dayOfWeek = this.datePipe.transform(date, 'EEE');
        return dateString + "\n(" + dayOfWeek + ")";
      }),
      viewsData,
      viewsPerMinData
    }

    return graphStatsView;
  }

 isDateSelected(date: NgbDateStruct) {
    return this.selectedDates.findIndex(it => equals(it, date)) != -1;
  }

  onMouseDownDate($event, date: NgbDateStruct) {
    if (($event.buttons == undefined? $event.which : $event.buttons) && before(date, this.maxDate)) {
      let index = this.selectedDates.findIndex(it => equals(it, date));
      if (index >=0) {
        this.selectedDates.splice(index, 1);
        this.dateSelectionMode = false;
      } else {
        this.selectedDates.push(date);
        this.dateSelectionMode = true;
      }

      this.userSelectedDates = true
    }
  }

  onMouseUpDate($event, date: NgbDateStruct) {
    /*if (this.selectedDates.length) {
      let dates: Array<string> = [];
      this.selectedDates.forEach(date => {
        dates.push(this.formatDate(date));
      });
      this.refresh();
    }*/
  }

  public applyCalendar() {
    this.showCalendar = false; 
  }

  private padLeft(text:string, padChar:string, size:number): string {
      return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }

  private formatDate(date: NgbDateStruct): string {
    return date.year.toString()+"-"+this.padLeft(date.month.toString(), '0', 2)+"-"+this.padLeft(date.day.toString(), '0', 2);
  }

  public banned() {
    return this.auth.getAuth().isBanned();
  }

  onMouseOverDate($event, date) {
    if (($event.buttons == undefined? $event.which : $event.buttons) && before(date, this.maxDate)) {
      let index = this.selectedDates.findIndex(it => equals(it, date));
      
      if (index >=0) {
        if (!this.dateSelectionMode) {
          this.selectedDates.splice(index, 1);
        }
      } else {
        if (this.dateSelectionMode) {
          this.selectedDates.push(date);
        }
      }

      this.userSelectedDates = true
    }
  }

  // Function to format a number using decimal separator and thousands separator
  formatNumber(value: number, digits: string): string {
    // Use the DecimalPipe to format the number
    let formattedValue = this.decimalPipe.transform(value, digits);

    // Replace the commas with dots
    formattedValue = formattedValue.replace(/,/g, '|');

    // Replace the dots with commas
    formattedValue = formattedValue.replace(/\./g, ',');

    // Replace the temporary '|' with dots for the thousands separator
    formattedValue = formattedValue.replace(/\|/g, '.');

    return formattedValue;
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/dashboard.component.ts